import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  MenuOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Table, Input, Tooltip, message } from "antd";
import { useEffect, useState } from "react";
import rightTick from "../../assets/rightTick.png";
import cartIcon from "../../assets/cartIcon.png";
import { useSelector } from "react-redux";
import { axiosInstance } from "../../utils/axiosInterceptor";
import rightTickNew from '../../assets/righTick1.png'
import crossTick from '../../assets/crossTick.png'
import { useNavigate } from "react-router-dom";

const ProductTable = ({
  setData,
  data,
  current,
  pageSize,
  total,
  onPageChange,
  loading,
}) => {
  const [tempData, setTempData] = useState([]);
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  const navigate = useNavigate()

  useEffect(() => {
    const mapped = data?.map((item) => ({
      ...item,
      purchaseQty:
        item.purchaseQty && item.purchaseQty >= item.min_qty
          ? item.purchaseQty
          : item.min_qty,
      stockQty: item.quantity,
      newQuantity: 0,
    }));

    setTempData(mapped);
  }, [data]);

  const handleQuantityChange = (value, record) => {
    let newQty = parseInt(value);

    if (isNaN(newQty) || newQty < record.min_qty) {
      message.error(`Minimum quantity is ${record.min_qty}`);
      newQty = record.min_qty;
    }

    if (newQty > 1000) {
      message.error("Max order quantity is 1000");
      newQty = 1000;
    }
    if (newQty > record?.stockQty) {
      message.error(`Only ${record.stockQty} units available`);
      newQty = record.stockQty;
    }

    const updated = tempData?.map((item) =>
      item.product_code === record.product_code
        ? { ...item, purchaseQty: newQty }
        : item
    );

    setTempData(updated);
  };

  const handleAddToCart = async (product) => {
    if (!product?.purchaseQty || product?.purchaseQty <= 0) {
      message.info("Please enter valid quantity")
      return;
    }
    if (product?.purchaseQty < product?.min_qty) {
      message.error(`Min order quantity is ${product?.min_qty}`);
      return;
    }
    const payload = {
      userId: userAuth?.id,
      product_code: product?.product_code,
      quantity: product?.purchaseQty,
      supplier_name: product?.party_name
    }
    try {
      const response = await axiosInstance.post("marketplace/cart/add", payload);
      message.success(response?.data?.message);
    } catch (error) {
      console.log(error, "Error")
      message.error(error?.response?.data?.message)
    }
    finally {

    }
  };

  const columns = [
    {
      title: "NDC / Prod ID",
      dataIndex: "product_code",
      key: "product_code",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
            {/* <EyeOutlined color="#888" onClick={()=>navigate('/product-details')}/> */}
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: (a, b) =>
        String(a.product_code).localeCompare(String(b.product_code)),
    },
    {
      title: "Description",
      dataIndex: "product_name",
      key: "product_name",
      sorter: (a, b) =>
        String(a.product_name).localeCompare(String(b.product_name)),
    },
    {
      title: "Hist.",
      dataIndex: "hsc",
      key: "hsc",
      render: (hsc) =>
        hsc ? (
          <img src={rightTick} alt="" className="w-5 h-5" />
        ) : (
          <span>-</span>
        ),
    },
    {
      title: "Supplier",
      dataIndex: "party_name",
      key: "party_name",
      render: (v) => (v ? v : "-"),
      sorter: (a, b) =>
        String(a.party_name).localeCompare(String(b.party_name)),
    },
    {
      title: "GCR Impact",
      dataIndex: "gcr_impact",
      key: "gcr_impact",
      render: (impact) => (
        <Tooltip
          title={
            impact > 0
              ? "Positive Impact"
              : impact === 0
                ? "Average Impact"
                : "Negative Impact"
          }
        >
          {impact > 0 ? (
            <ArrowUpOutlined className="text-green-500" />
          ) : impact === 0 ? (
            <MenuOutlined className="text-gray-500" />
          ) : (
            <ArrowDownOutlined className="text-red-500" />
          )}
        </Tooltip>
      ),
    },
    {
      title: "Unit price",
      dataIndex: "unit_price",
      key: "unit_price",
      align: "right",
      render: (total) =>
        total !== null && total !== undefined
          ? `$ ${Number(
            total || 0
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
          : "-",
      sorter: (a, b) => a.unit_price - b.unit_price,
    },
    //  {
    //   title: "Price",
    //   dataIndex: "price",
    //   key: "price",
    //   render: (price) => `-`,
    //   // sorter: (a, b) => a.unit_price - b.unit_price,
    // },
    {
      title: "Avail.",
      key: "avail",
      render: (_, record) => (
        <Tooltip
          title={record.stockQty > 0 ? "Available" : "Not Available"}
        >
          {record.stockQty > 0 ? (
            // <CheckCircleOutlined className="text-green-500" />
            <img src={rightTickNew} alt="" className="w-5 h-5" />
          ) : (
            // <CloseCircleOutlined className="text-red-500" />
            <img src={crossTick} alt="" className="w-5 h-5" />
          )}
        </Tooltip>
      ),
    },
    {
      title: "Do Not Sub.",
      // dataIndex: "doNotSub",
      // key: "doNotSub",
      render: (doNotSub, record) => (
        // <Checkbox
        //   checked={true}
        //   // onChange={(e) => handleDoNotSubChange(e.target.checked, record)}
        //   className="rounded-sm"
        // />
        <span>-</span>
      ),
    },
    {
      title: "Purchase qty",
      key: "purchaseQty",
      render: (_, record) => (
        <div className="flex items-center space-x-2">
          <Input
            type="number"
            min={record.min_qty}
            max={1000}
            value={record.purchaseQty}
            onChange={(e) =>
              handleQuantityChange(e.target.value, record)
            }
            className="w-20 text-right"
          />
          <Tooltip title="Add to cart">
            <img
              src={cartIcon}
              alt=""
              onClick={() => handleAddToCart(record)}
              className="h-7 w-7 cursor-pointer p-1 rounded-md hover:bg-gray-200"
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={tempData}
      rowKey="product_code"
      scroll={{ x: "max-content" }}
      loading={loading}
      className="custom-table user-tbl"
      pagination={{
        current,
        total,
        pageSize,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
      }}
      onChange={(pagination) =>
        onPageChange(pagination.current, pagination.pageSize)
      }
      rowClassName={(record) =>
        record.hsc ? "bg-[#ECFFD9]" : ""
      }
    />
  );
};

export default ProductTable;


